import { useMemo } from 'react'
import { catalog2tree, findPathToNode } from '@utils/explorerutils'
import TreeNode from './TreeNode/TreeNode'
import type {
  TreeNode as TreeNodeType,
  DataItemPayload
} from 'src/types/global'
import { useCatalog } from '@hooks/useCatalog'

interface Props {
  selectedId: string | undefined
  onSelect: (item: DataItemPayload) => void
}

export default function ExplorerTree({ selectedId, onSelect }: Props) {
  const catalog = useCatalog()
  const explorerData = useMemo(() => catalog2tree(catalog.datasets), [catalog])

  const expandedIds = useMemo(() => {
    if (!selectedId) return new Set<string>()
    const path = findPathToNode(explorerData, selectedId)
    return path ? new Set(path) : new Set<string>()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId])

  const handleSelect = (node: TreeNodeType) => {
    if (node.type !== 'dataset' || !node.source) return

    onSelect({
      type: 'dataset',
      source: node.source,
      id: node.id,
      name: node.name
    })
  }

  if (!explorerData.length) return <div>No data</div>

  return (
    <nav className="data-explorer">
      <ul>
        {explorerData.map((node) => (
          <TreeNode
            key={'data-explorer-' + node.id}
            node={node}
            selectedId={selectedId}
            onSelect={handleSelect}
            expandedIds={expandedIds}
          />
        ))}
      </ul>
    </nav>
  )
}
